import { useEffect } from 'react';

import commonSycurioTelephonicEntryService from '../../../services/commonCheckout/commonSycurioTelephonicEntryService';

export default function useStartSycurioTelephonicEntry({
  checkoutSessionId,
  startSpinner,
  setCasiTransactionId,
}: {
  checkoutSessionId: string;
  startSpinner: () => void;
  setCasiTransactionId: (
    currentState: React.SetStateAction<string | undefined>,
  ) => void;
}) {
  useEffect(() => {
    if (!checkoutSessionId) {
      return;
    }
    (async () => {
      startSpinner();
      try {
        const casiResponse =
          await commonSycurioTelephonicEntryService({
            checkoutSessionId,
            eventType: 'startSycurio',
          });
        setCasiTransactionId(casiResponse?.data?.requestId);
      } catch {
        console.error(
          'Error starting sycurio telephonic entry session',
        );
      }
    })();
  }, [checkoutSessionId]);
}
